import 'firebase/auth';
import 'firebase/database';

import firebase from 'firebase/app';

import { firebaseConfig } from '../constants/defaultValues';

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const database = firebase.database();

export { auth, database };
